<div class="login-page">

  <!-- Decorative elements -->
  <img class="deco deco--top-left"    src="assets/sketches/1.png"  alt="" aria-hidden="true" />
  <img class="deco deco--top-right"   src="assets/sketches/6.png"  alt="" aria-hidden="true" />
  <img class="deco deco--bottom-right" src="assets/sketches/5.png" alt="" aria-hidden="true" />
  <img class="deco deco--plant"        src="assets/sketches/3.png" alt="" aria-hidden="true" />
  <img class="deco deco--heart"        src="assets/sketches/4.png" alt="" aria-hidden="true" />

  <!-- Two-column layout -->
  <div class="page-content">

    <!-- Left: illustration -->
    <div class="illustration-col">
      <img class="doctor-img" src="assets/sketches/female-doc.png" alt="Doctor at computer" />
    </div>

    <!-- Right: form -->
    <div class="form-col">

      <h1 class="login-title" *ngIf="environment.nameLabel == 'gateway'">{{'login.gatewayTitle' | translate}}</h1>
      <h1 class="login-title" *ngIf="environment.nameLabel !== 'gateway'">{{'login.title' | translate}}</h1>
      <p class="login-sub" *ngIf="environment.nameLabel == 'gateway'">{{'login.subtitleGateway' | translate}}</p>
      <p class="login-sub" *ngIf="environment.nameLabel !== 'gateway'">{{'login.subtitle' | translate}}</p>

      <div class="alertWrapper">
        <nb-alert *ngIf="showMessages.error && errors?.length" outline="danger" role="alert">
          <p class="alert-title" style="text-align: center;"><b>{{'login.errorTitle' | translate}}</b></p>
          <div class="alert-message-list">
            <span *ngFor="let error of errors" class="alert-message">{{ error }}</span>
          </div>
        </nb-alert>

        <nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert" style="word-wrap: break-word">
          <p class="alert-title"><b>{{'login.successTitle' | translate}}</b></p>
          <ul class="alert-message-list">
            <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
          </ul>
        </nb-alert>
      </div>

      <div class="host">
        <div class="panes" [@slide]="showElements">

          <div class="stepOne" [nbSpinner]="twoFAsubmitted"
               nbSpinnerStatus="primary" nbSpinnerSize="giant" nbSpinnerMessage="">

            <form (ngSubmit)="sendTwoFA()" #form="ngForm" aria-labelledby="title">

              <div *ngIf="environment.childOrMasterOrGateway == 'gateway'" class="form-control-group">
                <label class="label" for="input-clientCode">{{'login.clientCode' | translate}}</label>
                <input nbInput fullWidth
                       [(ngModel)]="user.clientCode" #clientCode="ngModel"
                       name="clientCode" id="input-clientCode"
                       [placeholder]="'login.clientCodePlaceholder' | translate" fieldSize="large" autofocus
                       [status]="clientCode.dirty ? (clientCode.invalid ? 'danger' : 'success') : 'basic'"
                       [required]="true"
                       [attr.aria-invalid]="clientCode.invalid && clientCode.touched ? true : null">
                <ng-container *ngIf="clientCode.invalid && clientCode.touched">
                  <p class="caption status-danger" *ngIf="clientCode.errors?.required">{{'login.clientCodeRequired' | translate}}</p>
                  <p class="caption status-danger" *ngIf="clientCode.errors?.pattern">{{'login.clientCodeTypo' | translate}}</p>
                </ng-container>
              </div>

              <div class="form-control-group">
                <label class="label" for="input-email">{{'login.email' | translate}}</label>
                <input nbInput fullWidth
                       [(ngModel)]="user.email" #email="ngModel"
                       [showStatusIconOn]="['valid','invalid']"
                       name="email" id="input-email"
                       pattern=".+@.+\..+" [placeholder]="'login.emailPlaceholder' | translate"
                       fieldSize="large" autofocus
                       [status]="email.dirty ? (email.invalid ? 'danger' : 'success') : 'basic'"
                       [required]="getConfigValue('forms.validation.email.required')"
                       [attr.aria-invalid]="email.invalid && email.touched ? true : null">
                <ng-container *ngIf="email.invalid && email.touched">
                  <p class="caption status-danger" *ngIf="email.errors?.required">{{'login.emailRequired' | translate}}</p>
                  <p class="caption status-danger" *ngIf="email.errors?.pattern">{{'login.emailTypo' | translate}}</p>
                </ng-container>
              </div>

              <div class="form-control-group">
                  <label class="label" for="input-password">{{'login.password' | translate}}</label>
                <input nbInput fullWidth
                       [(ngModel)]="user.password" #password="ngModel"
                       name="twoFA" type="password" id="input-password"
                       [placeholder]="'login.passwordPlaceholder' | translate" fieldSize="large"
                       [status]="password.dirty ? (password.invalid ? 'danger' : 'success') : 'basic'"
                       [required]="getConfigValue('forms.validation.password.required')"
                       [minlength]="getConfigValue('forms.validation.password.minLength')"
                       [maxlength]="getConfigValue('forms.validation.password.maxLength')"
                       [attr.aria-invalid]="password.invalid && password.touched ? true : null">
                <ng-container *ngIf="password.invalid && password.touched">
                  <p class="caption status-danger" *ngIf="password.errors?.required">{{'login.passwordRequired' | translate}}</p>
                  <p class="caption status-danger" *ngIf="password.errors?.minlength || password.errors?.maxlength">
                    {{'login.passwordLength' | translate : { min: getConfigValue('forms.validation.password.minLength'), max: getConfigValue('forms.validation.password.maxLength') } }}
                  </p>
                </ng-container>
              </div>

              <div class="form-control-group accept-group">
                <nb-checkbox name="rememberMe" [(ngModel)]="user.rememberMe" *ngIf="rememberMe">{{'login.rememberMe' | translate}}</nb-checkbox>
              </div>
              <div class="login-actions">
                <button id="loginButton" nbButton fullWidth status="primary" size="large"
                [disabled]="submitted || !form.valid" [class.btn-pulse]="submitted">
                  {{'login.logIn' | translate}}
                </button>

                <button nbButton fullWidth outline status="primary" size="large"
                type="button"
                routerLink="/forgot-password">
                  {{'login.forgotPassword' | translate}}
                </button>
              </div>


            </form>
          </div>

          <div class="stepTwo" [class.fadeIn]="showElements == 'twoFA'">
            <form (ngSubmit)="loginWithTwoFa()" #form="ngForm" aria-labelledby="title">
              <div class="form-control-group">
                <label class="label" for="input-twoFA">{{'login.twoFACode' | translate}}</label>
                <input nbInput fullWidth
                       [(ngModel)]="user.twoFAtoken" #twoFA="ngModel"
                       name="twoFA" id="input-twoFA"
                       [placeholder]="'login.twoFAPlaceholder' | translate" fieldSize="large" autofocus
                       [status]="twoFA.dirty ? (twoFA.invalid ? 'danger' : 'success') : 'basic'"
                       [required]="true"
                       [attr.aria-invalid]="twoFA.invalid && twoFA.touched ? true : null">
                <ng-container *ngIf="twoFA.invalid && twoFA.touched">
                  <p class="caption status-danger" *ngIf="twoFA.errors?.required">{{'login.twoFARequired' | translate}}</p>
                  <p class="caption status-danger" *ngIf="twoFA.errors?.pattern">{{'login.twoFAInvalid' | translate}}</p>
                </ng-container>
              </div>

              <button nbButton fullWidth status="primary" size="large"
                      [disabled]="twoFAsubmitted || !form.valid" [class.btn-pulse]="submitted">
                {{'login.logIn' | translate}}
              </button>
            </form>
          </div>

        </div>
      </div>

    </div>
  </div>
</div>
